/** 是否在微信内置浏览器（可发起网页授权） */
export function isWeChatEmbeddedBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /MicroMessenger/i.test(navigator.userAgent);
}
